import React, { Dispatch, SetStateAction, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import AddNewDictionaryElementModal from "src/app/modals/AddNewDictionaryElementModal/AddNewDictionaryElementModal";
import { RootState } from "src/redux/reducers";
import { getDictionary, clearDictionary } from "src/redux";

interface DictionaryTableAddNewDictionaryElementModalProps {
  onClose: () => void;
  dictionaryUuid: string;
  setElementToScrollUuid: Dispatch<SetStateAction<string | null>>;
}

export default function DictionaryTableAddNewDictionaryElementModal({
  onClose,
  dictionaryUuid,
  setElementToScrollUuid,
}: DictionaryTableAddNewDictionaryElementModalProps) {
  const dispatch = useDispatch();

  const {
    dictionaryReducer: { dictionary, isDictionaryLoading },
  } = useSelector((state: RootState) => state);

  useEffect(() => {
    dispatch(getDictionary(dictionaryUuid));
  }, [dictionaryUuid, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearDictionary());
    };
  }, [dispatch]);

  return (
    <AddNewDictionaryElementModal
      onClose={onClose}
      dictionaryUuid={dictionaryUuid}
      setElementToScrollUuid={setElementToScrollUuid}
      isLoading={isDictionaryLoading}
      fields={dictionary?.metaFields || []}
    />
  );
}
